var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconsContentProfile(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17 7c0 2.786-2.214 5-5 5a4.97 4.97 0 01-5-5c0-2.786 2.214-5 5-5s5 2.214 5 5zM4.929 14.143c1.357-.714 2.714-.714 2.785-.714h8.572c2 0 5.714 1.214 5.714 5.714 0 .143 0 1.286-.857 2.071-.5.5-1.143.786-2 .786H4.857C2.786 22 2 20.286 2 19.143c0-2.929 1.571-4.357 2.929-5z",
    fill: "red"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xNyA3QzE3IDkuNzg1NzEgMTQuNzg1NyAxMiAxMiAxMkM5LjIxNDI5IDEyIDcgOS43ODU3MSA3IDdDNyA0LjIxNDI5IDkuMjE0MjkgMiAxMiAyQzE0Ljc4NTcgMiAxNyA0LjIxNDI5IDE3IDdaTTQuOTI4NTcgMTQuMTQyOUM2LjI4NTcxIDEzLjQyODYgNy42NDI4NiAxMy40Mjg2IDcuNzE0MjkgMTMuNDI4NkgxNi4yODU3QzE4LjI4NTcgMTMuNDI4NiAyMiAxNC42NDI5IDIyIDE5LjE0MjlDMjIgMTkuMjg1NyAyMiAyMC40Mjg2IDIxLjE0MjkgMjEuMjE0M0MyMC42NDI5IDIxLjcxNDMgMjAgMjIgMTkuMTQyOSAyMkg0Ljg1NzE0QzIuNzg1NzEgMjIgMiAyMC4yODU3IDIgMTkuMTQyOUMyIDE2LjIxNDMgMy41NzE0MyAxNC43ODU3IDQuOTI4NTcgMTQuMTQyOVoiIGZpbGw9InJlZCIvPgo8L3N2Zz4K";
export { SvgIconsContentProfile as ReactComponent };